'use strict';

import angular from 'angular';
import '../app.js';
import {RunConfigService} from '@nuskin/ns-util';

angular.module('checkout').controller('DowntimeCtrl', ['$scope', 'nsDowntime', async function($scope, nsDowntime) {
    if (window.ReactNativeWebView) {
        $scope.hideHeader = true;
        $scope.hideFooter = true;
    }
    $scope.runConfig = RunConfigService.getRunConfig();
    $scope.contentLoaded = false;
    await nsDowntime.getDowntime(`${$scope.runConfig.language}_${$scope.runConfig.country}`);
    $scope.downtimeMessage = nsDowntime.getMessage();
    $scope.contentLoaded = true;
    $scope.$apply();
}]);
